import React from 'react';
import Relay from 'react-relay';
import Select from 'react-select';
// import { isValidEmailAddress } from '../../components/UserPanel';

import Button from '../../components/Button';

// const userTypeOptions = [{
//   value: 'PERSON',
//   label: 'PERSON',
// }, {
//   value: 'BUSINESS',
//   label: 'BUSINESS',
// }, {
//   value: 'ORGANIZATION',
//   label: 'ORGANIZATION',
// }, {
//   value: 'SOLETRADER',
//   label: 'SOLETRADER',
// }]

class ChatsPage extends React.Component {
    state = {
        currentFilter: 'ALL',
        searchContent: '',
        searchByUserType: null,
        searchBySportId: null,
        searchBySportLevel: null,
    }

    componentWillMount() {
      if (this.props.location.pathname === '/chats') {
        this.props.router.push({
            pathname: '/chats/list/all',
            state: {
              filter : 'ALL',
            }
        });
      }
    }

    _onButtonClick() {
        let {that, text} = this.props;
        that.setState({
            currentFilter: text
        });

        let path = '/chats/list/'+text.toLowerCase();
        that.props.router.push({
            pathname : path,
            state :{
                filter : text,
            }
        });
    }

    _renderFilterButton(filterName, index) {
        let color = 'btn-default';

        if (filterName == this.state.currentFilter) {
        color = 'btn-danger';
        }

        return <Button
                text={filterName}
                key={index}
                that={this}
                color={color}
                onClick={this._onButtonClick}
                />
    }

    _updateSearch = () => {
      const newCurrentFilter = this.state.currentFilter === ''? 'All' : this.state.currentFilter
      const newState = {
        search: this.state.searchContent,
        searchBySportId: this.state.searchBySportId,
        currentFilter: newCurrentFilter,
      }

      if (this.state.currentFilter !== newCurrentFilter) {
        const pathname = '/users/list/all';
        this.props.router.push({
          pathname,
          state :{
            ...newState,
            filter : 'All',
          }
        });
      }

      this.setState(newState);
    }

    _handleSearchInputChange = (e) => {
      clearTimeout(this._handleSearchInputChange.timeout)
      this.setState({
        searchContent: e.target.value,
      })
      this._handleSearchInputChange.timeout = setTimeout(this._updateSearch, 400)
    }

    _renderChildren = ({ search, searchByUserType, searchBySportId, searchBySportLevel }, { children }) =>
      React.Children.map(children, child =>
        React.cloneElement(child, {
          search,
          // searchByUserType,
          // searchBySportId,
          // searchBySportLevel,
          // pseudo: !isValidEmailAddress(search)? search? search : undefined : undefined,
          // email: isValidEmailAddress(search)? search : undefined,
          // filter: searchBySportId? ({
          //   sportID: searchBySportId,
          //   level: searchBySportLevel? searchBySportLevel : undefined,
          // }) : undefined,
        })
      )

    _getLevelSelectFrom = (sportId) => this.props.viewer &&
      this.props.viewer.sports.edges.find(({ node: { id } }) => id === sportId)
        .node.levels.map(({ EN: { name }}) => ({ value: name, label: name }))

    _handleUserTypeSelectChange = (option) => {
      this.setState({
        searchByUserType: (option || {}).value,
      }, () => this._updateSearch())
    }

    _handleSportLevelSelectChange = (option) =>
      this.setState({ searchBySportLevel: (option || {}).value })

    render() {
        let filters = ["All"];
        const { selectLevels } = this.state

        return (
        <div className="container">
            <div style={{marginTop:20}}>
                {filters.map((filterName,index) => this._renderFilterButton(filterName,index))}
                {/*<div style={styles.total}>Total: {this.props.viewer.AdminStatistics }</div>*/}
                {/*<div style={styles.searchContainer}>
                  <input
                    onChange={this._handleSearchInputChange}
                    value={this.state.searchContent}
                    placeholder='Search by pseudo or email'
                    style={styles.input}
                  />
                </div>
                <div style={styles.sportSelectContainer}>
                  <Select
                    placeholder='Search by Type'
                    options={userTypeOptions}
                    value={this.state.searchByUserType}
                    onChange={this._handleUserTypeSelectChange}
                  />
                </div>*/}
            </div>
            {this._renderChildren(this.state, this.props)}
        </div>
        );

    }
}

const styles = {
  total: {
    display: 'inline-block',
    marginLeft: 15,
  },
  searchContainer: {
    display: 'inline-block',
    marginLeft: 15,
    padding: 10,
  },
  input: {
    borderRadius: 20,
    padding: 5,
    minWidth: 250,
  },
  sportSelectContainer: {
    display: 'inline-block',
    marginLeft: 15,
    minWidth: 200,
    height: 26,
  },
}


export default Relay.createContainer(ChatsPage, {
  fragments: {
    viewer: () => Relay.QL`
      fragment on Viewer {
        id
      }
    `,
  }
})



// WEBPACK FOOTER //
// ./src/pages/Chats/ChatsPage.js